let guid = 0

export default function (): number {
  return ++guid
}
